export function extractDatePartsFromStringToObject(dateString) {
    const regex = /^(\d{1,2})?\.(\d{1,2})?\.(\d{1,4})?$/;
    const match = regex.exec(dateString);
    const values = match ? match.slice(1).map(x => Number(x) || null) : [ null, null, null ];

    return {
        'day': values[0],
        'month': values[1],
        'year': values[2]
    };
}

export function dateObjectToString(dateObj) {
    if (dateObj == null) {
        return '';
    }
    const day = dateObj.day == null ? '' : dateObj.day;
    const month = dateObj.month == null ? '' : dateObj.month;
    const year = dateObj.year == null ? '' : dateObj.year;
    return  day + '.' + month + '.' + year;
}

export function mergeStartAndEndDatesToString(startDateObj, endDateObj) {
    const day = mergeStartAndEndPartToString(startDateObj.day, endDateObj.day);
    const month = mergeStartAndEndPartToString(startDateObj.month, endDateObj.month);
    const year = mergeStartAndEndPartToString(startDateObj.year, endDateObj.year);
    return day === '-' && month === '-' && year === '-' ? '' : day + '.' + month + '.' + year;
}

function mergeStartAndEndPartToString(startPart, endPart) {
    if (startPart == null && endPart == null) {
        return '-';
    }
    const startPartStr = startPart > 9 ? String(startPart) : '0' + String(startPart);
    const endPartStr = endPart > 9 ? String(endPart) : '0' + String(endPart);

    if (startPart === endPart) {
        if (startPart != null) {
            return startPartStr;
        }
    } else {
        return startPartStr + '-' + endPartStr ;
    }
    return '-';
}